import {Highlight} from "@/autocomplete/components/Highlight";
import {useConfigContext} from "@/ConfigProvider";
import {useHitAttributesAutocomplete} from "@/hooks/useHitAttributes";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export function ProductTile({hit, postFixLink}) {

    const {algoliaConfig:{customizedUrl,isCatalog}} = useConfigContext();

    const itemLink = "/" + customizedUrl + hit?.itemLink;

    const {tc} = useConfigContext();
    const hitAttributes = useHitAttributesAutocomplete(hit);

    if(isCatalog){
        return (
            <li id={`item_${hit.itemId}`} key={`product-${hit.objectID}`}
                className="itembox js-updateAlgoliaItemboxElement" data-itemno={hit.itemNo}
                data-item-id={hit.itemId}
                role={"listitem"}
            >
                <a href={itemLink + "?search_query=" + postFixLink} title={hit.description} data-gtm-item={hit.itemId}
                   className="itembox__main gtm-product-click">
                    <div className="itembox__head">
                        <div className="itembox__image">
                            <img className="itembox__imageSrc"
                                 src={hit?.itemImage}
                                 width="300" height="300" loading="lazy"/>
                        </div>
                        <div className="itembox__badges">
                            <div className="promotions algoliaPromotionsWrapper">
                            </div>
                        </div>
                    </div>
                    <div className="itembox__content">
                        <div className="itembox__name">
                        <span>
                        <Highlight hit={hit} attribute="description"/>
                        </span>
                        </div>
                    </div>
                </a>
            </li>
        );
    }
    return (
        <li
            key={hit.objectID}
            id={'item_' + hit.itemId}
            className="algoliaSearchItemBox itembox itembox--imageLeft js-updateAlgoliaItemboxElement"
            role="listitem"
            data-itemno={hit.itemNo}
            data-item-id={hit.itemId}
        >
            <div className="itembox__contentContainer">
                <div className="itembox__head">
                    <a
                        href={itemLink}
                        title={hit.description}
                        data-gtm-item={hit.itemId}
                        className="itembox__main gtm-product-click"
                    >
                        <div className="itembox__image">
                            <img
                                className="itembox__imageSrc"
                                src={hit?.itemImage}
                                alt={hit.description}
                                width="300"
                                height="300"
                                loading="lazy"
                            />
                        </div>
                        <div className="itembox__badges">
                            <div
                                className="promotions algoliaPromotionsWrapper"
                                suppressHydrationWarning
                            />
                        </div>

                        <div className="itembox__actions">
                            <div
                                className="algoliaFavoriteWrapper"
                                suppressHydrationWarning
                            >
                              <span className="actionIcon">
                                <i className="icon icon-favorites" aria-hidden={true}></i>
                              </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div className="itembox__content">
                    <nav className="itembox__tags marginBottom--small">
                        <ul>
                            {hitAttributes.map((attribute, index) => (
                                attribute && <li key={index}><span className="textLink">{attribute}</span></li>
                            ))}
                        </ul>
                    </nav>
                    <a
                        href={itemLink}
                        title={hit.description}
                        data-gtm-item={hit.itemId}
                        className="itembox__main gtm-product-click"
                    >
                        <div className="itembox__name marginBottom">

                            <span className="itembox__brand"></span>
                            <Highlight hit={hit} attribute="description"/>
                        </div>

                        <div className="itembox__summary marginBottom--small">
                            {hit.summary}
                        </div>
                    </a>

                    <div className="itembox__prices algoliaPrices" suppressHydrationWarning>
                        <div className="prices loading">
                            <span className="basePrice loadSkeleton">XXX,XX €</span>
                        </div>
                    </div>

                    <div className="itembox__inventory algoliaInventorySign" suppressHydrationWarning>
                        <div className="inventoryWrapper loading">
                            <div className="inventory">
                                <p className="loadSkeleton">XXX,XX</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {hit.hasVariants ? (
                    <div className="orderButtonWrapper">
                        <a href={itemLink} className="variantButton">
                            <span>{hit.numberOfVariants} {tc.variants}</span>
                            <i className="icon icon-arrow-right-long" aria-hidden="true"></i>
                        </a>
                    </div>
                ) :
                (
                    <form
                        name={'form_' + hit.itemNo}
                        id={'form_' + hit.itemNo}
                        method="POST"
                        data-action="shop_add_all_items_to_basket"
                        className="itembox__addon algoliaOrderbuttonWrapper"
                        suppressHydrationWarning
                    >
                        <div className="orderButtonWrapper inactive">
                            <div className="quantity quantity--inactive">
                                <input type="number" value="0" min="1" disabled />
                                <div className="quantity__spinner">
                                    <div className="quantity__spinnerItem quantity__spinnerItem--up">
                                        <i className="icon icon-spinner-up"></i>
                                    </div>
                                    <div className="quantity__spinnerItem quantity__spinnerItem--down">
                                        <i className="icon icon-spinner-down"></i>
                                    </div>
                                </div>
                            </div>
                            <button
                                type="submit"
                                className="orderButton button button--primary disabled"
                                disabled
                            >
                                <span className="loadSkeleton">Warenkorb</span>
                                <i className="icon icon-basket" aria-hidden="true"></i>
                            </button>
                        </div>
                    </form>
                )
            }
        </li>
    );
}
